const NoTasksEmptyStateIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Featured icon">
        <path
          d="M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z"
          fill="#F5F5F5"
        />
        <g id="check-done-01">
          <path
            id="Icon"
            d="M21 31.4999L23.3333 33.8333L28.5833 28.5833M23.3333 23.3333V20.0666C23.3333 18.7598 23.3333 18.1064 23.5876 17.6073C23.8113 17.1682 24.1683 16.8113 24.6073 16.5876C25.1065 16.3333 25.7599 16.3333 27.0666 16.3333H35.9333C37.2401 16.3333 37.8935 16.3333 38.3926 16.5876C38.8317 16.8113 39.1886 17.1682 39.4123 17.6073C39.6666 18.1064 39.6666 18.7598 39.6666 20.0666V28.9333C39.6666 30.24 39.6666 30.8934 39.4123 31.3926C39.1886 31.8316 38.8317 32.1886 38.3926 32.4123C37.8935 32.6666 37.2401 32.6666 35.9333 32.6666H32.6666M20.0666 39.6666H28.9333C30.2401 39.6666 30.8935 39.6666 31.3926 39.4123C31.8317 39.1886 32.1886 38.8316 32.4123 38.3926C32.6666 37.8934 32.6666 37.24 32.6666 35.9333V27.0666C32.6666 25.7598 32.6666 25.1064 32.4123 24.6073C32.1886 24.1682 31.8317 23.8113 31.3926 23.5876C30.8935 23.3333 30.2401 23.3333 28.9333 23.3333H20.0666C18.7599 23.3333 18.1065 23.3333 17.6073 23.5876C17.1683 23.8113 16.8113 24.1682 16.5876 24.6073C16.3333 25.1064 16.3333 25.7598 16.3333 27.0666V35.9333C16.3333 37.24 16.3333 37.8934 16.5876 38.3926C16.8113 38.8316 17.1683 39.1886 17.6073 39.4123C18.1065 39.6666 18.7599 39.6666 20.0666 39.6666Z"
            stroke="#717680"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default NoTasksEmptyStateIcon;
